import type { StatusType } from '@datadog/browser-logs';
import type { Env } from '@fff-web/constants';

export interface LogFn {
  (msg: LoggerMessageBuilderParams, obj?: object): void;
}

export type ClientLoggerConstructorParams = {
  token?: string;
  env: Env;
  logLevel?: StatusType;
  serverLogger: Logger | null;
};

export type ServerLoggerConstructorParams = Pick<ClientLoggerConstructorParams, 'logLevel'>;

export type Logger = {
  debug: LogFn;
  info: LogFn;
  warn: LogFn;
  error: LogFn;
};

export const loggerMessageContextValues = {
  api: 'API (Route Handler)',
  proxy: 'Proxy (Edge Runtime)',
  'server-action': 'Server Action (Server Component)',
  client: 'Browser (Client Component)',
  'server-function': 'Server Function (Server Component)',
  RSC: 'RSC (Server Component/Page)',
} as const;

export type LoggerMessageContext =
  `[${string} - ${(typeof loggerMessageContextValues)[keyof typeof loggerMessageContextValues]}]`;

export type LoggerMessageSessionContext = `(SessionId = ${string | undefined})`;

export type LoggerMessageContent = `${string} ${LoggerMessageSessionContext}`;

export type LoggerMessage = `${LoggerMessageContext} ${LoggerMessageContent}`;

export type LoggerMessageBuilderParams = {
  /**
   * Where is the message coming from.
   */
  type: keyof typeof loggerMessageContextValues;
  /**
   * The context of the message, e.g. 'Auth', 'Optimizely', etc...
   */
  context: string;
  /**
   * The message itself.
   */
  message: string;
  /**
   * The sessionId if available.
   */
  sessionId?: string;
};

export type LoggerMessageBuilderParamsPartial = Omit<
  LoggerMessageBuilderParams,
  'message' | 'sessionId'
>;
